<template>
  <form
    @submit.prevent="$router.push('/otp')"
    class="auth-form-container columnd"
  >
    <h1 class="text-start f28-700 c-darkBlue">Change Password</h1>
    <div class="inputs columnd">
      <h6 class="text-start f14-400 c-darkGrey">Please Change your password</h6>
      <div class="input-container">
        <span> Email Adrress </span>
        <label for="">
          <input placeholder="Email" type="text" />
        </label>
      </div>
      <div class="input-container">
        <span> Email Adrress </span>
        <label for="">
          <input placeholder="Email" type="text" />
        </label>
      </div>
      <button class="primary-btn">Change password</button>
    </div>
  </form>
</template>

<script>
export default {
  name: "NewPass",
};
</script>

<style lang="scss" scoped>
.input-check {
  gap: 3px;
  input {
    border: 1px solid var(--darkBlue);
    &:checked {
      background: none !important;
    }
  }
}
</style>
